import "isomorphic-fetch";
import {
  assetApi,
  devendpoint
} from '../api';
import { assetConstants } from '../_constants';
import { history } from '../_helpers';
import { checkUnauthorized } from '../_helpers/handleResponse';
import { fetchWithAuth } from '../_helpers/fetchWithAuth';
import { runCachedRequest } from '../_helpers/requestCache';

// export const assetActions = {
//     login,
//     logout,
//     getAll
// };

// export const ASSET_HAS_ERRORED = 'ASSET_HAS_ERRORED';
export function assetHasErrored(bool) {
  return {
    type: assetConstants.ASSET_HAS_ERRORED,
    hasErrored: bool
  };
}

// export const ASSET_IS_LOADING = 'ASSET_IS_LOADING';
export function assetIsLoading(bool) {
  return {
    type: assetConstants.ASSET_IS_LOADING,
    isLoading: bool
  };
}

// export const ASSET_FETCH_DATA_SUCCESS = 'ASSET_FETCH_DATA_SUCCESS';
export function assetFetchDataSuccess(asset) {
  return {
    type: assetConstants.ASSET_FETCH_DATA_SUCCESS,
    asset
  };
}

export function assetFetchData(id) {
  return async (dispatch) => {
    dispatch(assetIsLoading(true));
    
    try {
      const response = await runCachedRequest(
        `asset:${id}:metadata=true:files=true`,
        () => fetchWithAuth(`${devendpoint}/assets/${id}?includeMetadata=true&includeFiles=true`, {
          method: 'GET',
        }),
        { ttl: 30 * 1000 },
      );
      
      if (!response.ok) {
        checkUnauthorized(response, response.statusText);
        if(response.status === 403)
          history.push('/login');
        throw Error(response.statusText);
      }
      
      const asset = await response.json();

      dispatch(assetIsLoading(false));
      dispatch(assetFetchDataSuccess(asset));
      return asset;
    } catch (error) {
      dispatch(assetIsLoading(false));
      dispatch(assetHasErrored(true));
      throw error;
    }
  };
}

export function assetRequestRemove(assetId) {
  return dispatch => {
    dispatch(request(true));
    assetApi.requestRemove(assetId)
    .then(
      response => {
        dispatch(success(response.data));
        dispatch(request(false));
      },
      error => {
        dispatch(failure(error));
      }
    );
  };

  function request(isLoading) { return { type: assetConstants.ASSET_IS_LOADING, isLoading } }
  function success(asset) {
    return {
      type: assetConstants.ASSET_FETCH_DATA_SUCCESS,
      asset: {...asset.data, removalRequested: true},
    }
  }
  function failure(error) { return { type: assetConstants.ASSET_HAS_ERRORED, error } }
}
